// ----------------------------------------------------------------------

const shape = {
  borderRadius: 2,
  borderRadiusSm: 4,
  borderRadiusMd: 8
};

export default shape;
